import { render, staticRenderFns } from "./UpdateLocationComponent.vue?vue&type=template&id=7065b010&scoped=true&"
import script from "./UpdateLocationComponent.vue?vue&type=script&lang=js&"
export * from "./UpdateLocationComponent.vue?vue&type=script&lang=js&"
import style0 from "./UpdateLocationComponent.vue?vue&type=style&index=0&id=7065b010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7065b010",
  null
  
)

export default component.exports